import { en } from './en'
import { jp } from './jp'

export default {
  en,
  jp,
}
